module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pointer-events-none",
    attrs: {
      "id": "user-profile",
      "data-id": "userId"
    }
  }, [_c('div', {
    staticClass: "\n    absolute pin-l pin-r md:pin-t z-30\n    md:overflow-auto\n    pointer-events-auto \n    w-full md:w-2/5 md:max-w-sm\n    md:m-4\n    md:rounded shadow bg-white\n    text-white\n  "
  }, [_c('div', {
    staticClass: "cursor-pointer absolute pin-t pin-r py-2 px-2",
    on: {
      "click": _vm.closeButtonClicked
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "src": require("../assets/img/close-white.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix bg-brand"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('img', {
    staticClass: "block rounded z-10",
    attrs: {
      "src": _vm.profile.imageUrl
    }
  })]), _vm._v(" "), _c('csf-button', {
    staticClass: "text-sm mt-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('showRandom')
      }
    }
  }, [_vm._v("Show another learner")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd15022e","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/views/UserProfile.vue
// module id = 174
// module chunks = 0